/* eslint-disable no-param-reassign */
const stickyOverflow = function stickyOverflow() {
  // Add negative overflow to each sticky item
  const updateStickyOverflow = function updateStickyOverflow() {
    const stickyItems = document.querySelectorAll('[data-sticky-overflow]');

    stickyItems.forEach((element) => {
      const stickyItem = element;
      const stickyItemPadding = stickyItem.dataset.stickyOverflow;
      const headerSize = document.querySelector('.theme-header').offsetHeight;

      if (stickyItemPadding !== '') {
        const stickyItemPaddingElements = stickyItem.querySelectorAll(stickyItemPadding);

        stickyItemPaddingElements.forEach((elem) => {
          elem.style.paddingTop = headerSize + 'px';
        });
      } else {
        stickyItem.style.paddingTop = headerSize + 'px';
      }

      stickyItem.style.marginTop = '-' + headerSize + 'px';
    });
  };

  window.addEventListener('resize', updateStickyOverflow);
  window.addEventListener('orientationchange', updateStickyOverflow);
  document.addEventListener('slick:resize', updateStickyOverflow);
  updateStickyOverflow();
};

exports.default = stickyOverflow;
